import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { MultiSelect } from '../multi-select';
import { SkeletonLoader } from '../skeleton-loader';
import { Tooltip } from '../tooltip';
import { AssetGroupFilter, FilterControls } from './filter-types';
import { AssetGroupIcon } from '../../atoms/icons';

import { useTranslation } from 'react-i18next';

const MAX_TEXT_LENGTH = 27;

export const AssetGroupFC = ({
  error,
  data,
  id,
  label,
  loading,
  value,
  setValue,
  placement,
  hideIcon,
  onClose,
  fetchNextPage,
  hasNextPage,
  setManualQuery,
  permanent,
  displayMaxItems,
  selectText,
  showInlineClear,
  showOperator,
  wrapperClassName,
  dataTestId,
}: AssetGroupFilter & FilterControls) => {
  const { t } = useTranslation('designSystem');
  return (
    <SkeletonLoader
      status={loading ? 'loading' : error ? 'error' : 'success'}
      error={error}
      type="line"
      key={id}
    >
      <MultiSelect
        dataTestId={dataTestId}
        label={label || t('assetGroup')}
        loading={loading}
        allowSearch
        showOperator={showOperator}
        className={wrapperClassName}
        displayButtonClassName={wrapperClassName}
        options={
          data?.map(({ name, assetGroupId }) => {
            const isTextTruncated = name.length > MAX_TEXT_LENGTH;
            return {
              value: assetGroupId,
              searchString: name,
              label: (
                <div className="flex flex-col truncate">
                  <div className="flex items-center gap-1">
                    <div className="mr-1 truncate">{name}</div>
                    {isTextTruncated && (
                      <Tooltip
                        label={name || ''}
                        style={{
                          maxWidth: '500px',
                        }}
                      >
                        <InformationCircleIcon className="h-5 w-5 flex-shrink-0 text-gray-600 dark:text-gray-400" />
                      </Tooltip>
                    )}
                  </div>
                </div>
              ),
              selectedDisplay: name,
            };
          }) || []
        }
        icon={AssetGroupIcon}
        mode="multiple"
        showInlineClear={showInlineClear}
        showClear
        showSelectAll
        value={value}
        fetchNextPage={() => fetchNextPage?.()}
        hasNextPage={hasNextPage}
        setValue={setValue}
        hideIcon={hideIcon}
        placement={placement}
        displayMaxItems={displayMaxItems}
        onClose={onClose}
        selectText={selectText}
        setManualQuery={setManualQuery}
        permanent={permanent}
        virtualize
      />
    </SkeletonLoader>
  );
};
